import React from 'react';
import MinimumOffer from '../MinimumOffer';
import Countdown from '../Countdown';
import s from './MinOfferAndCountdown.scss';
const MinOfferAndCountdown = ({ adoptableState: { minOfferPrice, offerTimerHasEnded, onTimerEnd, offerEndTime } })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(MinimumOffer, {
        value: minOfferPrice
    }), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Countdown, {
        hasEnded: offerTimerHasEnded,
        offerEndTime: offerEndTime,
        onEnd: onTimerEnd
    }));
};
MinOfferAndCountdown.displayName = 'MinOfferAndCountdown';
export default MinOfferAndCountdown;
